import _ from 'underscore';
import dayjs from '../../../shared/services/dayjs.js';
import { schichtenService } from './services/SchichtenService.js';
import { stammdatenService } from './services/StammdatenService.js';
import { datumService } from './services/DatumService.js';
import {
	filterSchichtenMitarbeiter,
	findeQualifikation,
	findePosten,
	findeEinsatzort,
	convertNumberToEuro,
	convertNumberDE,
} from './util.js';
import { Egfz } from '../../../shared/services/Egfz.js';
import SystemDialogService from '../../../shared/services/systemDialogService.js';
import { zeigeKleineNachricht } from './systemNachricht.js';
import { Roles } from '../../../../domain/konstanten/Roles.js';
import { createSchichtElement, createSchichtPanel } from './components/shiftCard.js';
import { farbeFuerBereich } from './util/bereichFarben.js';
import { fuelleWetterBadges } from './components/weatherBadge.js';
import { istBereichSichtbar, istPostenSichtbar, istEinsatzortSichtbar, istQualifikationSichtbar, istSucheTreffer, istSucheAktiv, renderFilterPanel, zuruecksetzenFilter } from './components/filterPanel.js';
import { erstelleSchichtVorlageSelect, erstelleToolbarVorlagenSelect } from './components/templatesRail.js';
import { ladeBereichBedarfe, fuegeBereichBedarfZeileEin, aktualisiereBedarfZeilen } from './components/bedarfZeile.js';
import { berechneStatusWerte, formatStunden, STATUS_RESTURLAUB_KNAPP_TAGE } from './util/statusWerte.js';
import { oeffneMitarbeiterStatus } from './dialogs/mitarbeiterStatus.js';

window.tb = window.tb || {};

// Relevante HTML Elemente auf die oft zugegriffen wird
const gridContent = document.getElementById('grid-content');
// Posten-Schlüssel der Gesamtsummenzeile der Mitarbeiteransicht — nicht -1, da das (ausgeblendete)
// Wochenplan-Grid im DOM bleibt und dessen Gesamtsumme sonst dieselben IDs (`ma:-1:-1`, ...) hätte.
const MA_GESAMT_ID = 'ma-gesamt';
const gridScroll = document.getElementById('grid');
const schichtAddenTemplate = document.querySelector('[schicht-adden-template]');
// Monatsstunden (Plan / Plan bis heute / Ist) der Betriebsstätte samt Abrechnungszeitraum, siehe ladeStundenMonat()
let stundenMonat = { Mitarbeiter: {} };
let istAktuelleWoche = true;

/**
 * Zeigt einen Lade-Kreis nur über dem Grid-Bereich (nicht der ganzen Seite) während zeigeDienstplan()
 * neu lädt — ersetzt den alten seitenweiten #loader-div-Overlay für diesen Fall, siehe
 * toolbar.js:wechsleWoche und index.js für den entfernten globalen Aufruf.
 * @param {HTMLElement} gridEl Ziel-Grid-Scroll-Container (Default: #grid) — exportiert/parametrisiert,
 *   damit die Mitarbeiteransicht (#magrid) denselben Loader wiederverwenden kann, siehe
 *   views/mitarbeiteransichtView.js.
 */
function showGridLoader(gridEl = gridScroll) {
	if (!gridEl || gridEl.querySelector('.dp-grid-loader')) return;
	const loader = document.createElement('div');
	loader.className = 'dp-grid-loader';
	gridEl.appendChild(loader);
}

function hideGridLoader(gridEl = gridScroll) {
	gridEl?.querySelector('.dp-grid-loader')?.remove();
}
/**
 * Fügt eine neue Zeile im Dienstplan Template hinzu.
 * @param {int} ZeilenID kann MitarbeiterID sein oder ID für die Summenzeile (-1 ist für die TagesSumme)
 * @param {string} postenID für die GesamtSumme wird -1 verwendet. Ein leerer String ('') wird von der
 *   Mitarbeiteransicht als "kein fester Posten" verwendet (dedup'te Zeile über alle Postens hinweg) —
 *   ergibt gültige, eindeutige aber postenlose IDs (z.B. `ma::<MitarbeiterID>`).
 * @param {date} datum
 * @param {array} wunschzeiten
 * @param {HTMLElement} gridEl Ziel-Grid-Container (Default: das Wochenplan-#grid-content), damit
 *   dieselbe Zeilenerzeugung auch für die Mitarbeiteransicht (#magrid-content) wiederverwendet werden kann.
 */
function addGridRow(ZeilenID, postenID, datum, wunschzeiten = [], urlaubsantraege = [], eintrittMA = undefined, austrittMA = undefined, geburtsdatum = undefined, bereichID = undefined, gridEl = gridContent) {
	// Normale Mitarbeiterzeile, Postensumme (ZeilenID -1, postenID gesetzt) oder Gesamtsumme (beide -1)
	const istSummenzeile = ZeilenID === -1;
	const istGesamtzeile = istSummenzeile && (postenID === -1 || postenID === MA_GESAMT_ID);
	const maKlasse = istGesamtzeile ? 'macell tot grand' : istSummenzeile ? 'macell tot' : 'macell';
	const statusKlasse = istGesamtzeile ? 'statuscell tot-label grand' : istSummenzeile ? 'statuscell tot-label' : 'statuscell';
	const tagKlasseBasis = istGesamtzeile ? 'daycell tot grand' : istSummenzeile ? 'daycell tot' : 'daycell';
	const sumKlasse = istGesamtzeile ? 'sumcell grand' : 'sumcell';

	// Mitarbeiter Name
	const maNameDiv = document.createElement('div');
	maNameDiv.id = `ma:${`${postenID}:${ZeilenID}`}`;
	maNameDiv.className = maKlasse;
	maNameDiv.setAttribute('aria-level', postenID);
	if (bereichID) maNameDiv.dataset.bereich = bereichID;
	gridEl.appendChild(maNameDiv);
	// Mitarbeiter Status
	const maStatusDiv = document.createElement('div');
	maStatusDiv.id = `ms:${`${postenID}:${ZeilenID}`}`;
	maStatusDiv.className = statusKlasse;
	maStatusDiv.setAttribute('aria-level', postenID);
	if (bereichID) maStatusDiv.dataset.bereich = bereichID;
	gridEl.appendChild(maStatusDiv);
	const datumStart = dayjs(datum);
	for (let i = 0; i < 7; i += 1) { // Montag - Sonntag
		const tagesDatum = datumStart.add(i, 'days');
		const tagDiv = document.createElement('div');
		const istWochenende = i >= 5;
		tagDiv.className = `${tagKlasseBasis}${istWochenende ? ' we' : ''}`;
		tagDiv.id = `${i + 1}:${postenID}:${ZeilenID}`;
		tagDiv.setAttribute('aria-label', `${tagesDatum.format('DD.MM.YYYY')}`);
		tagDiv.setAttribute('aria-level', postenID);
		if (bereichID) tagDiv.dataset.bereich = bereichID;
		if (istSummenzeile) {
			gridEl.appendChild(tagDiv);
			continue;
		}
		const dateString = tagesDatum.format('YYYY-MM-DD');
		const daymeta = document.createElement('div');
		daymeta.className = 'daymeta';
		let hatMeta = false;
		// wunschzeitraum anzeigen
		if (!_.isEmpty(wunschzeiten)) {
			const wunschtag = wunschzeiten.find((wz) => {
				return dateString >= wz.ZeitraumVon && dateString <= wz.ZeitraumBis;
			});
			if (!_.isEmpty(wunschtag)) {
				const positiv = !!wunschtag.ZeitraumPositiv;
				tagDiv.classList.add(positiv ? 'pos' : 'neg');
				const badge = document.createElement('span');
				badge.className = `dbadge ${positiv ? 'pos' : 'neg'}`;
				badge.innerHTML = `<i class="bi bi-hand-thumbs-${positiv ? 'up' : 'down'}-fill"></i>${positiv ? 'gut' : 'ungünstig'}`;
				if (wunschtag.ZeitraumNotiz) badge.title = wunschtag.ZeitraumNotiz;
				daymeta.appendChild(badge);
				hatMeta = true;
			}
		}
		// Urlaub anzeigen (verhindert schicht hinzufügen)
		if (!_.isEmpty(urlaubsantraege)) {
			const hatUrlaub = urlaubsantraege.some((ua) => {
				return ua.UrlaubStatus === 'genehmigt' && dateString >= ua.UrlaubVon && dateString <= ua.UrlaubBis;
			});
			if (hatUrlaub) {
				const badge = document.createElement('span');
				badge.className = 'dbadge urlaub tag-urlaub';
				badge.innerHTML = '<i class="bi bi-airplane-fill"></i>Urlaub';
				badge.title = 'Die Person ist im Urlaub!';
				daymeta.appendChild(badge);
				hatMeta = true;
			}
		}
		// Falls es ein ein-/austrittsdatum gibt, können wir das anzeigen...
		if ((eintrittMA && tagesDatum.format('YYYY-MM-DD') < eintrittMA) || (austrittMA && tagesDatum.format('YYYY-MM-DD') > austrittMA)) {
			tagDiv.classList.add('inactive', 'ma-inaktiv');
		}
		// Falls es ein geburtsdatum gibt, können wir den geburtstag anzeigen...
		if (geburtsdatum) {
			const [yG, mG, dG] = geburtsdatum.split('-').map(Number);
			const [, mD, dD] = tagesDatum.format('YYYY-MM-DD').split('-').map(Number);
			if (mG === mD && dG === dD) {
				const badge = document.createElement('span');
				badge.className = 'dbadge cake tag-geburtstag';
				badge.innerHTML = '<i class="bi bi-cake2-fill"></i>Geburtstag';
				daymeta.appendChild(badge);
				hatMeta = true;
				tagDiv.title = 'Die Person hat heute Geburtstag.';
			}
		}
		if (hatMeta) tagDiv.appendChild(daymeta);
		gridEl.appendChild(tagDiv);
	}
	// Mitarbeiter Summe
	const maSummeDiv = document.createElement('div');
	maSummeDiv.className = sumKlasse;
	maSummeDiv.id = `ge:${`${postenID}:${ZeilenID}`}`;
	maSummeDiv.setAttribute('aria-level', postenID);
	if (bereichID) maSummeDiv.dataset.bereich = bereichID;
	gridEl.appendChild(maSummeDiv);
}

/**
 * Fügt eine Headerzeile für den Posten hinzu
 * @param {string} postenID
 * @param {array} posten Liste der Postene
 * @param {string} bereichFarbe Hex-Farbe des Bereichs, dem der Posten angehört (aus bereichFarben.js)
 * @param {number} anzahlMitarbeiter Anzahl der im Posten sichtbaren Mitarbeiter, für das Count-Badge
 * @param {string} bereichID BereichID des Postens, damit der Posten beim Ein-/Ausklappen des Bereichs mit-ein-/ausgeklappt wird
 */
function addHeaderRow(postenID, posten = [], bereichFarbe = undefined, anzahlMitarbeiter = undefined, bereichID = undefined) {
	const template = document.querySelector('[area-header-template]');
	const neueZeile = template.content.cloneNode(true).children[0];
	neueZeile.id = `${postenID}-header`;
	if (bereichID) neueZeile.dataset.bereich = bereichID;
	neueZeile.querySelector('[area-header-title]').innerText = posten.find((b) => b._id === postenID).Posten;
	if (anzahlMitarbeiter !== undefined) {
		neueZeile.querySelector('[area-header-count]').innerText = anzahlMitarbeiter;
	}
	if (bereichFarbe) {
		neueZeile.querySelector('.badge').style.background = bereichFarbe;
	}
	// Button config für mitarbeiter auswahl
	const auswahlButton = neueZeile.querySelector('[area-header-auswahl]');
	auswahlButton.id = `${postenID}-auswahl`;
	auswahlButton.addEventListener('click', (event) => {
		event.stopPropagation();
		window.tb.mitarbeiterAuswahlPosten(postenID);
	});
	// Button config für Posten Freigabe
	const freigabeButton = neueZeile.querySelector('[area-header-freigabe]');
	freigabeButton.id = `${postenID}-freigabe`;
	freigabeButton.addEventListener('click', (event) => {
		event.stopPropagation();
		window.tb.schichtenFreigebenWoche(postenID);
	});
	gridContent.appendChild(neueZeile);
}

/**
 * Fügt eine Bereichs-Kopfzeile ein — einmal pro sichtbarem Bereich, oberhalb seiner Posten-Header —
 * mit einer Aktion, um alle Schichten des GANZEN Bereichs auf einmal freizugeben (nicht nur eines
 * einzelnen Postens wie beim bestehenden Posten-Header, siehe addHeaderRow/schichtenFreigebenWoche).
 * @param {object} bereich
 * @param {string} bereichFarbe Hex-Farbe des Bereichs (aus bereichFarben.js)
 */
function addBereichHeaderRow(bereich, bereichFarbe) {
	const row = document.createElement('div');
	row.className = 'bereich-header areahead';
	row.id = `${bereich._id}-bereich-header`;
	row.style.setProperty('--bereich-farbe', bereichFarbe);
	row.innerHTML = '<i class="bi bi-chevron-down ch"></i><span class="badge"><i class="bi bi-diagram-3-fill"></i></span>'
		+ `<span class="nm">${bereich.Bereich}</span><span class="sp"></span>`;
	row.addEventListener('click', () => toggleBereich(bereich._id, row));
	const freigabeButton = document.createElement('span');
	freigabeButton.className = 'ahbtn ok bereich-header-freigabe';
	freigabeButton.innerHTML = '<i class="bi bi-share-fill"></i>Bereich freigeben';
	freigabeButton.title = `Alle Schichten im Bereich "${bereich.Bereich}" für diese Woche freigeben`;
	freigabeButton.addEventListener('click', (event) => {
		event.stopPropagation();
		window.tb.schichtenFreigebenBereich(bereich._id);
	});
	row.appendChild(freigabeButton);
	gridContent.appendChild(row);
}

/**
 * Klappt einen ganzen Bereich (Posten-Header + deren Mitarbeiterzeilen + Posten-/Bereichssumme)
 * ein oder aus. Analog zu fun.togglePosten, aber über alle [data-bereich]-Zeilen des Bereichs statt
 * nur über einen einzelnen Posten (aria-level).
 * @param {string} bereichID
 * @param {HTMLElement} headerElement
 */
function toggleBereich(bereichID, headerElement) {
	document.querySelectorAll(`[data-bereich="${bereichID}"]`).forEach((item) => item.classList.toggle('hidden'));
	headerElement.classList.toggle('area-header-closed');
}

/**
 * Füllt den Bereich HTML Select mit den verfügbaren Bereichen
 * @param {array} bereiche Liste der Posten
 */
function fuelleBereichSelect(bereiche = []) {
	const bereichSelect = document.getElementById('bereich-select');
	bereichSelect.innerHTML = '';
	bereiche.forEach((b) => {
		const newOption = document.createElement('option');
		newOption.setAttribute('value', b.BereichID);
		newOption.innerText = b.Bereich;
		newOption.value = b._id;
		bereichSelect.appendChild(newOption);
	});
}

/**
 * Befüllt den Dienstplan mit allen Daten und Controls
 * @param {boolean} initialised boolean ob der Dienstplan schonmal erzeugt wurde, meistens true
 * @param {boolean} betriebWechsel boolean ob die Stammdaten Posten & Mitarbeiter neugeladen werden soll
 * @param {boolean} bereichWechsel boolean ob ein anderer Bereich geladen werden sollen
 * @param {boolean} maRefresh boolean ob die Mitarbeiter neugeladen werden sollen
 * @param {boolean} nurToolbar nur Bereich-/Vorlagen-Select befüllen, Raster nicht aufbauen (Start in anderer Ansicht)
 */
 async function zeigeDienstplan(initialised = true, betriebWechsel = false, bereichWechsel = false, maRefresh = false, nurToolbar = false) {
	aktualisiereKwAnzeige();
	// resetten des grids
	gridContent.innerHTML = '';
	gridContent.style.display = 'none';
	showGridLoader();
	document.body.style.cursor = 'wait';
	// Die Kopierquelle-Vorschau lebt außerhalb von #grid-content und bleibt deshalb
	// über Wochen-/Bereich-/Betriebswechsel hinweg sichtbar. Nichts zu tun hier.
	// laden aller relevanten Daten (die aktuelle betriebsstätteID wird aus dem stammdatenService geladen),
	// parallel, da unabhängig voneinander (beim ersten Laden sonst fünf Requests nacheinander)
	const [postenListe, einsatzorte, mitarbeiterliste, qualifikationen, unternehmen] = await Promise.all([
		stammdatenService.getPosten(betriebWechsel),
		stammdatenService.getEinsatzorte(betriebWechsel),
		stammdatenService.getMitarbeiter(betriebWechsel || maRefresh),
		stammdatenService.getQualifikationen(),
		stammdatenService.getUnternehmensdaten(),
	]);
	const mitarbeiterAktiv = filterMitarbeiterAktiv(mitarbeiterliste);
	unternehmen.Bereiche.sort((a, b) => a.Bereich.localeCompare(b.Bereich));
	const bereicheAktiv = unternehmen.Bereiche.filter((bereich) => bereich.Verwenden);
	const bereichePostenAktiv = bereicheAktiv.filter((bereich) => postenListe.some((posten) => _.isEqual(posten.BereichID, bereich._id)));
	if (!initialised) {
		fuelleBereichSelect(bereichePostenAktiv);
	}
	// Falls es schon ein Vorlagenselect gibt, erstellen wir ein neues bei einem Betriebswechsel, Bereichwechsel oder Initialisierung
	if (betriebWechsel || !initialised || bereichWechsel) {
		await erstelleToolbarVorlagenSelect();
	}
	initialised = true;

	// Nur Toolbar befüllen (Bereich-/Vorlagen-Select), das Raster aber nicht aufbauen: beim Start in einer
	// anderen Ansicht (?view=...) rendert die ohnehin selbst, der Wochenplan wird beim Tab-Wechsel frisch gerendert.
	if (nurToolbar) {
		if (bereichePostenAktiv.length === 0) {
			await SystemDialogService.instance.displayAsync('keine-bereiche-dialog');
		}
		hideGridLoader();
		document.body.style.cursor = 'default';
		return;
	}

	// Filter-Panel: welche Bereiche/Posten/Einsatzorte/Qualifikationen sichtbar sein sollen. Anders als
	// früher gibt es kein einzelnes "ausgewähltes" Bereich mehr, das den Dienstplan gated — standardmäßig
	// sind alle Bereiche/Posten/Einsatzorte/Qualifikationen sichtbar, siehe components/filterPanel.js.
	renderFilterPanel(bereichePostenAktiv, postenListe, einsatzorte, qualifikationen, mitarbeiterAktiv, () => zeigeDienstplan(true), passeVorlagenBereichAn);

	if (bereichePostenAktiv.length > 0) {
		// Lade alle Schichten der Betriebsstätte (Filterung passiert clientseitig über das Filter-Panel),
		// parallel dazu die Monatsstunden für die Statuszellen
		const [alleSchichten] = await Promise.all([schichtenService.getSchichten(datumService.laufendesDatum), ladeStundenMonat()]);
		// Einmalig: Map<MitarbeiterID → Set<PostenID>> aus den Schichten aufbauen
		const schichtenPostenByMA = new Map();
		// Schichten je Zeile (`${MitarbeiterID}:${PostenID}`) — die Suche prüft nur die Schichttitel DIESER Zeile.
		const schichtenNachZeile = new Map();
		for (const s of alleSchichten) {
			if (!schichtenPostenByMA.has(s.MitarbeiterID)) schichtenPostenByMA.set(s.MitarbeiterID, new Set());
			schichtenPostenByMA.get(s.MitarbeiterID).add(s.PostenID);
			const zeile = `${s.MitarbeiterID}:${s.PostenID}`;
			if (!schichtenNachZeile.has(zeile)) schichtenNachZeile.set(zeile, []);
			schichtenNachZeile.get(zeile).push(s);
		}
		// Nur der DienstplanerMitBudget, Betriebsleiter und Sachbearbeiter sollten die AG Kosten einsehen
		const zeigeAgKosten = window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget);
		const sichtbareBereiche = bereichePostenAktiv.filter((b) => istBereichSichtbar(b._id));
		// Spaltenköpfe + Tagesnotizen-Zeile müssen als erste Kinder von .wgrid stehen (reine DOM-Reihenfolge, kein grid-template-areas mehr)
		await zeigeWochenDaten();
		// Offener Bedarf der Woche: einmal laden, dann je Bereich eine Zeile unter dem Bereichskopf (s. Schleife).
		// Änderungen aus dem Bedarf-Dialog gezielt einsetzen statt das ganze Raster neu zu laden.
		const bedarfKontext = await ladeBereichBedarfe(gridContent, {
			neuLaden: (aenderung) => wendeBedarfAenderungAn(aenderung, {
				gridIdFuer: (s) => `${s.Wochentag.Zahl}:${s.PostenID}:${s.MitarbeiterID}`,
				neuLaden: () => zeigeDienstplan(true),
			}),
		});
		for (const bereich of sichtbareBereiche) {
			// Zuerst alle sichtbaren Posten des Bereichs herausfiltern... Bei aktiver Suche zusätzlich nur Posten
			// mit mindestens einer passenden Zeile (sonst bleiben lauter leere Posten-/Bereichsköpfe stehen).
			const postenInBereich = postenListe.filter((po) => po.BereichID === bereich._id
				&& istPostenSichtbar(po._id)
				&& (!istSucheAktiv() || sichtbareMitarbeiterImPosten(po, mitarbeiterAktiv, schichtenPostenByMA, schichtenNachZeile).length > 0));
			if (postenInBereich.length === 0) {
				continue; // alle Posten dieses Bereichs sind rausgefiltert -> keinen leeren Bereichs-Header zeigen
			}
			addBereichHeaderRow(bereich, farbeFuerBereich(unternehmen.Bereiche, bereich._id));
			// Offener Bedarf dieses Bereichs direkt unter dem Kopf (nur wenn es offene Bedarfe gibt).
			fuegeBereichBedarfZeileEin(gridContent, bereich._id, bedarfKontext);
			for (const posten of postenInBereich) {
				// Posten pro Posten die Schichten anzeigen...
				const postenSchichten = alleSchichten.filter((s) => s.PostenID === posten._id);
				// hier werden die Zeilen der Mitarbeiter erstellt pro Posten...
				zeigePostenZeilen(postenListe, posten, mitarbeiterAktiv, schichtenPostenByMA, unternehmen.Bereiche, schichtenNachZeile);
				zeigeSchichten(alleSchichten, posten, postenListe);
				if (zeigeAgKosten) {
					zeigePostenSummen(posten._id, postenSchichten, mitarbeiterAktiv, posten.BereichID, `Summe ${posten.Posten}`);
				}
			}
			// Bereichs-Zwischensumme (eigene Zeile pro Bereich, daher bereich._id statt -1 als Schlüssel)
			if (zeigeAgKosten && postenInBereich.length > 0) {
				const alleSchichtenBereich = alleSchichten.filter((s) => _.pluck(postenInBereich, '_id').includes(s.PostenID));
				zeigePostenSummen(bereich._id, alleSchichtenBereich, mitarbeiterAktiv, bereich._id, `Summe ${bereich.Bereich}`);
			}
		}
		// Gesamtsumme über alle sichtbaren Bereiche/Posten hinweg
		if (zeigeAgKosten) {
			const sichtbarePostenIDs = _.pluck(postenListe.filter((po) => istBereichSichtbar(po.BereichID) && istPostenSichtbar(po._id)), '_id');
			const sichtbareSchichten = alleSchichten.filter((s) => sichtbarePostenIDs.includes(s.PostenID));
			zeigePostenSummen(-1, sichtbareSchichten, mitarbeiterAktiv);
		}
		// Hier werden die Mitarbeiter Daten angezeigt pro Mitarbeiter pro Posten
		await zeigeMitarbeiter(mitarbeiterAktiv, qualifikationen, alleSchichten, schichtenPostenByMA, postenListe, unternehmen.Bereiche);
		zeigeSchichtAddenControls();
		const auswahlBS = unternehmen.Betriebsstaette.find((bs) => bs._id === stammdatenService.aktuelleBetriebsstaette);
		await zeigeFeiertage(auswahlBS);
		gridContent.style.display = 'grid';
	} else {
		await SystemDialogService.instance.displayAsync('keine-bereiche-dialog');
	}
	hideGridLoader();
	document.body.style.cursor = 'default';
}

/**
 * Zeigt die Feiertage farblich im Dienstplan an.
 * @param {object} betriebsstaette
 */
async function zeigeFeiertage(betriebsstaette) {
	const feiertageBundesland = await datumService.fetchFeiertage(betriebsstaette.Bundesland, betriebsstaette.Feiertage);
	const datumStart = datumService.laufendesDatum;
	for (let i = 0; i < 7; i++) {
		const datumTmp = datumStart.add(i, 'days');
		const dateString = datumTmp.format('DD.MM.YYYY');
		const isFeiertag = feiertageBundesland[dateString];
		if (isFeiertag) {
			const gridItems = document.querySelectorAll(`[aria-label="${dateString}"]`);
			gridItems.forEach((item) => {
				item.classList.add('feiertag');
			});
			const datumHeader = document.getElementById(`date:${datumTmp.day() == 0 ? 7 : datumTmp.day()}`);
			const label = document.createElement('div');
			label.classList.add('feiertag-label');
			label.innerText = isFeiertag.fname;
			datumHeader.appendChild(label);
		}
	}
}

/**
 * Füllt das Schicht Vorlagen Select in der Toolbar mit Optionen.
 */
/**
 * Filter die mitarbeiter Liste nach Austrittsdatum
 * @param {array<object>} mitarbeiterliste
 * @returns aktive mitarbeiterliste
 */
function filterMitarbeiterAktiv(mitarbeiterliste) {
	// Wochengrenzen einmal vorab berechnen: endOf()/format() auf dem TZ-Datum sind teuer und wären sonst pro Mitarbeiter fällig.
	const wochenStart = datumService.laufendesDatum.format('YYYY-MM-DD');
	const wochenEnde = datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD');
	const mitarbeiterAktiv = mitarbeiterliste.filter((ma) => {
		const beschaeftigung = ma.Beschaeftigung[0];
		// Falls es kein Eintrittsdatum wird der Mitarbeiter angezeigt (es macht keinen Sinn nur ein Austrittsdatum zu haben...)
		if (!beschaeftigung.Eintrittsdatum || beschaeftigung.Eintrittsdatum === '') {
			return true;
		}
		// falls es kein Austrittsdatum gibt, muss das Eintrittsdatum gleich oder vor dem laufendem Wochendatum sein...
		if (!beschaeftigung.Austrittsdatum || beschaeftigung.Austrittsdatum === '') {
			return wochenEnde >= beschaeftigung.Eintrittsdatum;
		}
		// Ansonsten ist der MA aktiv, falls das aktuelle Wochendatum zwischen Ein- und Austrittsdatum liegt.
		/**
		 * BSP:
		 * Woche 20.10. - 26.10.2025
		 * Eintritt 19.10.2025 <= 26.10.2025 y
		 * Eintritt 22.10.2025 <= 26.10.2025 y
		 * Austritt 22.10.2025 >= 20.10.2025 y
		 * Austritt 30.10.2025 >= 20.10.2025 y
		 * Austritt 17.10.2025 >= 20.10.2025 n
		 */
		return wochenEnde >= beschaeftigung.Eintrittsdatum && wochenStart <= beschaeftigung.Austrittsdatum;
	});
	return mitarbeiterAktiv;
}

/**
 * Setzt das Filter-Panel zurück (alles wieder sichtbar) und rendert den Dienstplan neu.
 * @param {function} renderCallback rendert die aktuell sichtbare Ansicht neu — Default zeigeDienstplan
 *   (Wochenplan). index.js verdrahtet hier stattdessen views/viewSwitcher.js:renderAktiveView, damit der
 *   gemeinsame "Zurücksetzen"-Button im Filter-Panel auch bei aktiver Mitarbeiteransicht diese statt des
 *   (dann unsichtbaren) Wochenplans neu rendert.
 */
async function filterZuruecksetzen(renderCallback = () => zeigeDienstplan(true)) {
	const postenListe = await stammdatenService.getPosten();
	const einsatzorte = await stammdatenService.getEinsatzorte();
	const qualifikationen = await stammdatenService.getQualifikationen();
	const mitarbeiterAktiv = filterMitarbeiterAktiv(await stammdatenService.getMitarbeiter());
	const unternehmen = await stammdatenService.getUnternehmensdaten();
	const bereicheAktiv = unternehmen.Bereiche.filter((bereich) => bereich.Verwenden);
	const bereichePostenAktiv = bereicheAktiv.filter((bereich) => postenListe.some((posten) => _.isEqual(posten.BereichID, bereich._id)));
	zuruecksetzenFilter(bereichePostenAktiv, postenListe, einsatzorte, qualifikationen, mitarbeiterAktiv, renderCallback);
}

/**
 * Die Mitarbeiterzeilen eines Postens, die nach allen Filtern (Qualifikation, Einsatzort, Suche) sichtbar sind.
 * Zugeordnete Mitarbeitende und solche mit Schichten in diesem Posten bekommen eine Zeile.
 * @param {object} posten
 * @param {array<object>} mitarbeiter
 * @param {Map<string, Set<string>>} schichtenPostenByMA
 * @param {Map<string, array<object>>} schichtenNachZeile Schichten je `${MitarbeiterID}:${PostenID}`
 */
function sichtbareMitarbeiterImPosten(posten, mitarbeiter, schichtenPostenByMA, schichtenNachZeile) {
	return mitarbeiter.filter((m) => {
		const aktivZugeordnet = m.Beschaeftigung[0].Posten.some((b) => b.PostenID === posten._id);
		const hatSchichten = schichtenPostenByMA.get(m._id)?.has(posten._id) ?? false;
		const aktiveQualifikationen = m.Beschaeftigung[0].Verguetung.filter((v) => v.Verwenden).map((v) => v.QualifikationID);
		const aktiveEinsatzorte = (m.Beschaeftigung[0].Einsatzorte ?? []).map((e) => e.EinsatzortID);
		return (aktivZugeordnet || hatSchichten)
			&& istQualifikationSichtbar(aktiveQualifikationen)
			&& istEinsatzortSichtbar(aktiveEinsatzorte)
			&& istSucheTreffer(m, schichtenNachZeile.get(`${m._id}:${posten._id}`) ?? []);
	});
}

/**
 * Erstellt Grid Header Zeilen für den bestimmten Posten
 * @param {array} postenListe Liste an Posten
 * @param {object} posten der Posten, der gerendert wird
 * @param {array<object>} mitarbeiter Liste an Mitarbeitern
 * @param {array<object>} bereiche unternehmen.Bereiche, für die Bereichsfarbe des Headers
 * @param {Map<string, array<object>>} schichtenNachZeile Schichten je `${MitarbeiterID}:${PostenID}` (für die Suche)
 */
function zeigePostenZeilen(postenListe, posten, mitarbeiter, schichtenPostenByMA, bereiche = [], schichtenNachZeile = new Map()) {
	const sichtbareMitarbeiter = sichtbareMitarbeiterImPosten(posten, mitarbeiter, schichtenPostenByMA, schichtenNachZeile);
	addHeaderRow(posten._id, postenListe, farbeFuerBereich(bereiche, posten.BereichID), sichtbareMitarbeiter.length, posten.BereichID);
	for (const m of sichtbareMitarbeiter) {
		addGridRow(m._id, posten._id, datumService.laufendesDatum, m.Uebersicht.Wunschzeiten, m.Beschaeftigung[0].Urlaubsantraege, m.Beschaeftigung[0].Eintrittsdatum, m.Beschaeftigung[0].Austrittsdatum, m.Personalien?.Geburtsdatum, posten.BereichID);
	}
}

/**
 * Gibt die Tagessummen des jeweiligen Postens an
 * - Für Bereichsumme folgendes als Parameter angeben:
 * ```
 * postenID = -1
 * ```
 * @param {string} postenID
 * @param {array<object>} postenSchichten
 * @param {array<object>} mitarbeiter
 * @param {string} bereichID BereichID der Summenzeile, damit sie beim Ein-/Ausklappen des Bereichs mitgeht (nicht gesetzt bei der Gesamtsumme über alle Bereiche)
 * @param {string} label Zeilenbeschriftung (z.B. "Summe Kellner·in"/"Summe Service") — wird nur beim
 *   ersten Erzeugen der Zeile gesetzt, siehe unten; bei Folgeaufrufen (z.B. nach dem Speichern einer
 *   einzelnen Schicht) existiert die Zeile bereits und die Beschriftung bleibt unverändert.
 */
function zeigePostenSummen(postenID, postenSchichten, mitarbeiter, bereichID = undefined, label = undefined, gridEl = gridContent) {
	// Falls es die Zeile schon gibt, müssen wir sie nicht neu rendern (und die Beschriftung nicht neu setzen)...
	if (document.getElementById(`ma:${postenID}:-1`) === null) {
		addGridRow(-1, postenID, datumService.laufendesDatum, [], [], undefined, undefined, undefined, bereichID, gridEl);
		document.getElementById(`ma:${postenID}:-1`).innerText = label ?? 'Summe Bereiche';
	}
	// Spaltenbeschriftung für die Tages-/Wochenzellen, bei Posten-/Bereichs-Zwischensummen wie bei der
	// Gesamtsumme über alle Bereiche (dort auf navy Hintergrund, siehe .statuscell.grand).
	document.getElementById(`ms:${postenID}:-1`).innerHTML = 'Stunden<br>Kosten';
	let gesamtSumme = 0;
	let gesamtStunden = 0;
	for (let i = 1; i <= 7; i += 1) {
		let tagesSumme = 0;
		let tagesStunden = 0;
		const tagesSchichten = postenSchichten.filter((bs) => bs.Wochentag.Zahl === i);
		tagesSchichten.forEach((schicht) => {
			const arbeitszeit = schicht.BezahlteZeitGesamt;
			tagesStunden += schicht.BezahlteZeitGesamt;
			const ma = mitarbeiter.find((m) => m._id === schicht.MitarbeiterID);
			if (ma !== undefined) {
				const kosten = ma.Uebersicht.AGKostenProStunde;
				tagesSumme += arbeitszeit * kosten;
			}
		});
		const htmlID = `${i}:${postenID}:-1`;
		gesamtSumme += tagesSumme;
		gesamtStunden += tagesStunden;
		document.getElementById(htmlID).innerHTML = `<div class="h">${convertNumberDE(tagesStunden)} h</div><div class="k">${convertNumberToEuro(tagesSumme)}</div>`;
	}
	document.getElementById(`ge:${postenID}:-1`).innerHTML = `<div class="h">${convertNumberDE(gesamtStunden)} h</div><div class="k">${convertNumberToEuro(gesamtSumme)}</div>`;
}

/**
 * Zeigt die Mitarbeiter und dessen Qualifikationen in den ersten 2 Spalten an
 * @param {array} schichten
 * @param {array} mitarbeiter
 * @param {string} postenID
 */
async function zeigeMitarbeiter(mitarbeiter, qualifikationen, schichten, schichtenPostenByMA, postenListe = [], bereiche = [], postenID = undefined) {
	for (const m of mitarbeiter) {
		const aktivePosIds = new Set(m.Beschaeftigung[0].Posten.map((p) => p.PostenID));
		const maPosten = schichtenPostenByMA.get(m._id) ?? new Set();
		const extraPosten = [...maPosten].filter((id) => !aktivePosIds.has(id)).map((id) => ({ PostenID: id }));
		const allePosten = [...m.Beschaeftigung[0].Posten, ...extraPosten];
		for (const p of allePosten) {
			// wenn wir nur einen Posten anzeigen wollen, überspringen wir alle anderen
			if (postenID !== p.PostenID && postenID) {
				continue;
			}
			const mitarbeiterElement = document.getElementById(`ma:${p.PostenID}:${m._id}`);
			const monatElement = document.getElementById(`ms:${p.PostenID}:${m._id}`);
			if (!mitarbeiterElement) {
				continue;
			}
			const bereichID = findePosten(postenListe, p.PostenID)?.BereichID;
			const bereichFarbe = bereichID ? farbeFuerBereich(bereiche, bereichID) : undefined;
			await zeigeMitarbeiterZelle(m, qualifikationen, schichten, mitarbeiter, mitarbeiterElement, monatElement, bereichFarbe, p.PostenID);
		}
	}
}

/**
 * Füllt eine einzelne Mitarbeiter-Zeile (Mitarbeiter-Spalte + Status-Spalte + Wochensumme) — der Kern
 * von zeigeMitarbeiter()'s Posten-Schleife, extrahiert damit die Mitarbeiteransicht (dedup'te Zeile
 * ohne Posten-Bezug, siehe views/mitarbeiteransichtView.js) dieselbe Logik wiederverwenden kann.
 * @param {object} m Mitarbeiterobjekt
 * @param {array} qualifikationen
 * @param {array} schichten alle Schichten der Woche (für die Summenberechnung)
 * @param {array} mitarbeiter komplette Mitarbeiterliste (für zeigeMitarbeiterStunden)
 * @param {HTMLElement} mitarbeiterElement das `ma:...` Zellen-Element
 * @param {HTMLElement} monatElement das `ms:...` Zellen-Element
 * @param {string} bereichFarbe Hex-Farbe für den Avatar (aus bereichFarben.js)
 * @param {string} postenID PostenID für die Summenberechnung (leerer String bei der Mitarbeiteransicht)
 */
/**
 * Spaltenkopf „Status“. Untertitel: in der aktuellen Woche "Stand heute", sonst der Abrechnungsmonat der
 * Plan-/Ist-Stunden (z.B. "Okt. 2026"). Resturlaub und Gutzeit-Saldo sind immer Stände von heute — das
 * steht im Tooltip. Erwartet, dass ladeStundenMonat() vorher gelaufen ist. Wird von Wochenplan und
 * Mitarbeiteransicht genutzt.
 * @returns {HTMLElement}
 */
function erstelleStatusKopf() {
	const heute = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ);
	const zeitraum = stundenMonat.Zeitraum;
	const kopf = document.createElement('div');
	kopf.className = 'colhead';
	const zeitraumText = zeitraum ? `Plan-/Ist-Stunden ${dayjs(zeitraum.Start).tz().format('DD.MM.')}–${dayjs(zeitraum.Ende).tz().format('DD.MM.YYYY')} · ` : '';
	kopf.title = `${zeitraumText}Resturlaub und Gutzeit-Saldo Stand heute, ${heute.format('DD.MM.YYYY')}`;
	const untertitel = istAktuelleWoche || !zeitraum ? `Stand ${heute.format('DD.MM.')}` : dayjs.tz(zeitraum.Monat, dayjs.tz.DEFAULT_TZ).format('MMM YYYY');
	kopf.innerHTML = `Status<small>${untertitel}</small>`;
	return kopf;
}

/**
 * Lädt die Monatsstunden für die Statuszellen. Bezugsmonat ist der Monat von heute, falls heute in der
 * angezeigten Woche liegt, sonst der Monat des Donnerstags (Mehrheit der Wochentage).
 */
async function ladeStundenMonat() {
	const montag = datumService.laufendesDatum;
	const heute = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).format('YYYY-MM-DD');
	istAktuelleWoche = heute >= montag.format('YYYY-MM-DD') && heute <= montag.endOf('week').format('YYYY-MM-DD');
	stundenMonat = await schichtenService.getStundenMonat(istAktuelleWoche ? heute : montag.add(3, 'day').format('YYYY-MM-DD'));
}

/**
 * Inhalt der Statuszelle (Spalte 2 im Wochenplan und in der Mitarbeiteransicht), siehe
 * reference/statuszelle_v2/STATUSZELLE.md. Zwei Spuren auf gemeinsamer Skala: geplante Monatsstunden
 * (Dienstplan + EGFZ) gegen das Monatssoll und erfasste Ist-Stunden (EGFZ + Zeiterfassung bis jetzt).
 * Die Abweichung vergleicht Ist mit "Plan bis heute", nicht mit dem ganzen Monat. Darunter reine Zahlen:
 * Resturlaub, Gutzeit-Saldo und — nur für Budget-Rollen — AG-Kosten pro Stunde.
 * @param {object} m Mitarbeiter
 * @param {object} optionen
 * @param {boolean} optionen.zeigeAgKosten Spalte €/h anzeigen?
 * @param {boolean} optionen.urlaubsantraegeOffen offener Urlaubsantrag → amber Punkt am Flugzeug
 * @returns {{html: string, over: boolean, ariaLabel: string}}
 */
function renderStatusZelle(m, { zeigeAgKosten, urlaubsantraegeOffen }) {
	// Kennzahlen gemeinsam mit dem Mitarbeiter-Status-Dialog, siehe util/statusWerte.js
	const {
		plan, planBisHeute, ist, soll, over, skala, unterplant, abweichung, abwKlasse, abwText, rest, anspruch, ueb, agKosten: agKostenWert,
	} = berechneStatusWerte(m, stundenMonat.Mitarbeiter[m._id]);
	const pct = (wert) => (wert / skala) * 100;

	// Stunden-Kopf + Spuren (ohne Monatssoll, z.B. Minijob: nur die Zahl)
	let hrs;
	if (soll > 0) {
		const ueberSoll = over ? ` · ${formatStunden(over)} h über Soll` : '';
		const planFil = `<div class="fil${unterplant ? ' warn' : ''}${over ? ' over' : ''}" style="width:${pct(plan)}%"></div>`
			+ (over ? `<div class="tgt" style="left:${pct(soll)}%"></div>` : '');
		const titel = `Geplant ${formatStunden(plan)} von ${formatStunden(soll)} h Monatssoll${ueberSoll} · Plan bis heute ${formatStunden(planBisHeute)} h · Ist ${formatStunden(ist)} h (${abwText})`;
		hrs = `<div class="hrs" title="${titel}">`
			+ `<div class="hd"><span class="big">${formatStunden(plan)}</span><span class="of">/ ${formatStunden(soll)} h</span><span class="dv ${abwKlasse}">${abwText}</span></div>`
			+ '<div class="duo">'
			+ `<span class="l">Plan</span><div class="trk">${planFil}</div><span class="n2">${formatStunden(plan)}</span>`
			+ `<span class="l">Ist</span><div class="trk"><div class="fil erf ${abwKlasse}" style="width:${pct(ist)}%"></div></div><span class="n2">${formatStunden(ist)}</span>`
			+ '</div></div>';
	} else {
		hrs = `<div class="hrs" title="Geplante Stunden im Monat (kein Monatssoll hinterlegt)"><div class="hd"><span class="big">${formatStunden(plan)}</span><span class="of">h geplant</span></div></div>`;
	}

	// Zahlenreihe: Resturlaub · Gutzeit-Saldo · (AG-Kosten/h)
	const restText = formatStunden(rest);
	const urlaubTitel = `Resturlaub ${restText}${anspruch > 0 ? ` von ${formatStunden(anspruch)}` : ''} Tage${urlaubsantraegeOffen ? ' · offener Urlaubsantrag' : ''}`;
	const uebText = `${ueb > 0 ? '+' : ''}${formatStunden(ueb)}`;
	// In der Zelle ganze Stunden (Platz: Saldi können dreistellig sein), der genaue Wert steht im Tooltip.
	const uebGerundet = Math.round(ueb) || 0; // || 0 vermeidet "−0"
	const uebKurz = `${uebGerundet > 0 ? '+' : ''}${formatStunden(uebGerundet)}`;
	const nums = [
		`<div class="n${rest <= STATUS_RESTURLAUB_KNAPP_TAGE ? ' warn' : ''}" title="${urlaubTitel}">`
			+ `<span class="k"><i class="bi bi-airplane-fill ua-antrag-icon"></i>${urlaubsantraegeOffen ? '<span class="pend"></span>' : ''}</span>`
			+ `<span class="v">${restText}<em>d</em></span></div>`,
		`<div class="n${uebGerundet < 0 ? ' neg' : ''}" title="Gutzeit-Saldo: ${uebText} h"><span class="k">GZ</span><span class="v">${uebKurz}<em>h</em></span></div>`,
	];
	if (zeigeAgKosten) {
		const agKosten = convertNumberDE(agKostenWert, 2);
		nums.push(`<div class="n" title="Geschätzte Arbeitgeberkosten pro Stunde: ${agKosten} €/h"><span class="k klein">€/h</span><span class="v">${agKosten}</span></div>`);
	}

	// Vorlesetext für Screenreader (die Zelle ist als Button ausgezeichnet)
	const teile = [soll > 0
		? `${formatStunden(plan)} von ${formatStunden(soll)} Stunden geplant${over ? `, ${formatStunden(over)} über Soll` : ''}`
		: `${formatStunden(plan)} Stunden geplant`];
	if (soll > 0) {
		const abwBetrag = `${formatStunden(Math.abs(abweichung))} ${abweichung < 0 ? 'weniger' : 'mehr'}`;
		const abwVorlesen = abwKlasse !== 'ok' ? abwBetrag : (abwText === '±0 h' ? 'wie geplant' : `wie geplant, ${abwBetrag}`);
		teile.push(`Bis heute ${formatStunden(planBisHeute)} geplant, ${formatStunden(ist)} erfasst, ${abwVorlesen}`);
	}
	teile.push(`Resturlaub ${restText} Tage${urlaubsantraegeOffen ? ', offener Urlaubsantrag' : ''}`);
	teile.push(`Gutzeit-Saldo ${ueb > 0 ? 'plus ' : ''}${formatStunden(ueb)} Stunden`);
	if (zeigeAgKosten) teile.push(`${convertNumberDE(agKostenWert, 2)} Euro pro Stunde`);
	teile.push('Details öffnen');

	return {
		html: `${hrs}<div class="nums">${nums.join('')}</div>`,
		over: over > 0,
		ariaLabel: `${teile.join('. ')}.`,
	};
}

/** Urlaubsanträge (Abschnitt im Mitarbeiter-Status-Dialog) sehen und bearbeiten nur diese Rollen. */
function darfUrlaubsantraege() {
	return [Roles.Sachbearbeiter, Roles.DienstplanerMitBudget, Roles.DienstplanerOhneBudget, Roles.Zeitenpfleger]
		.some((rolle) => window.myVars.UserRoles.includes(rolle));
}

/**
 * Schreibt den Inhalt einer Statuszelle (beim Aufbau und nach Schichtänderungen, ohne Event-Listener).
 * @param {HTMLElement} monatElement das `ms:...` Zellen-Element
 * @param {object} m Mitarbeiter
 */
function fuelleStatusZelle(monatElement, m) {
	// UrlaubBis ist ein 'YYYY-MM-DD'-String → einfacher Stringvergleich; ein Antrag, der heute endet, zählt noch.
	const heute = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).format('YYYY-MM-DD');
	const urlaubsantraegeOffen = m.Beschaeftigung[0].Urlaubsantraege.some((ua) => ua.UrlaubStatus === 'offen' && heute <= ua.UrlaubBis);
	// Nur DienstplanerMitBudget, Betriebsleiter und Sachbearbeiter sehen die AG Kosten pro Stunde
	const zeigeAgKosten = window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget);
	const status = renderStatusZelle(m, { zeigeAgKosten, urlaubsantraegeOffen });
	monatElement.innerHTML = status.html;
	monatElement.classList.toggle('over', status.over);
	monatElement.setAttribute('aria-label', status.ariaLabel);
}

/**
 * Baut nach einer Schichtänderung alle Statuszellen der Person neu auf (eine je Posten-Zeile bzw. eine in
 * der Mitarbeiteransicht) — nur der Zelleninhalt, das Raster bleibt stehen.
 * @param {string} mitarbeiterID
 */
async function aktualisiereStatusZellen(mitarbeiterID) {
	const mitarbeiter = await stammdatenService.getMitarbeiter();
	const m = mitarbeiter?.find((ma) => ma._id === mitarbeiterID);
	if (!m) return;
	document.querySelectorAll(`[id^="ms:"][id$=":${mitarbeiterID}"]`).forEach((monatElement) => fuelleStatusZelle(monatElement, m));
}

async function zeigeMitarbeiterZelle(m, qualifikationen, schichten, mitarbeiter, mitarbeiterElement, monatElement, bereichFarbe, postenID) {
	const maInfoTemplate = document.querySelector('[mitarbeiter-info-template]');
	// Fülle die Spalte Mitarbeiter mit Avatar, Name und Qualifikationen
	const mitarbeiterInfo = maInfoTemplate.content.cloneNode(true);
	const avatar = mitarbeiterInfo.querySelector('[mitarbeiter-avatar]');
	avatar.innerText = `${m.Personalien.Vorname?.[0] ?? ''}${m.Personalien.Nachname?.[0] ?? ''}`.toUpperCase();
	if (bereichFarbe) avatar.style.setProperty('--bereich-farbe', bereichFarbe);
	// Profilbild (falls vorhanden) als kleines Vorschaubild über die Initialen legen: lazy und per ?v=<Stand>
	// dauerhaft im Browser gecached; die Initialen bleiben als Fallback (beim Laden, bei Fehlern, im Druck).
	if (m.AvatarStand) {
		const bild = document.createElement('img');
		bild.className = 'av-img hidden-print';
		bild.alt = '';
		bild.loading = 'lazy';
		bild.decoding = 'async';
		bild.addEventListener('error', () => bild.remove());
		bild.src = `/dienstplan/api/mitarbeiter/${m._id}/avatar?v=${encodeURIComponent(m.AvatarStand)}`;
		avatar.appendChild(bild);
	}
	const mitarbeteiterName = mitarbeiterInfo.querySelector('[mitarbeiter-name]');
	mitarbeteiterName.innerText = `${m.Personalien.Nachname}, ${m.Personalien.Vorname}`;
	// Personalnummer klein hinter dem Namen (auch über die Suche im Filter-Panel auffindbar).
	const personalnummer = m.Personalien?.Personalnummer;
	if (personalnummer !== undefined && personalnummer !== null && personalnummer !== '') {
		mitarbeiterInfo.querySelector('[mitarbeiter-personalnummer]').innerText = `#${personalnummer}`;
	}
	const qualisAusblenden = await stammdatenService.getQualifikationenAusblenden();
	if (!qualisAusblenden) {
		const qualiElement = mitarbeiterInfo.querySelector('[mitarbeiter-qualifikationen]');
		// Wir können die Qualifikation(en) des Mitarbeiters aus dem Verguetungsfeld der Beschäftigung lesen.
		for (let j = 0; j < m.Beschaeftigung[0].Verguetung.length; j += 1) {
			// Nur verwendete Qualifikationen anzeigen
			const verguetung = m.Beschaeftigung[0].Verguetung[j];
			if (verguetung.Verwenden) {
				const qualiTag = document.createElement('span');
				qualiTag.className = `qtag${verguetung.IstStandardQualifikation ? ' lead' : ''}`;
				qualiTag.innerText = qualifikationen.find((q) => q._id === verguetung.QualifikationID).BezeichnungNeutral;
				qualiElement.appendChild(qualiTag);
			}
		}
	}
	const mitarbeiterCheckbox = mitarbeiterInfo.querySelector('[mitarbeiter-auswahl]');
	mitarbeiterCheckbox.setAttribute('aria-label', m._id);
	mitarbeiterCheckbox.setAttribute('aria-level', postenID);
	mitarbeiterElement.appendChild(mitarbeiterInfo);
	fuelleStatusZelle(monatElement, m);
	// Die ganze Zelle öffnet den Mitarbeiter-Status-Dialog — daher als Button für Tastatur und Screenreader.
	monatElement.setAttribute('role', 'button');
	monatElement.tabIndex = 0;
	monatElement.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			monatElement.click();
		}
	});
	monatElement.addEventListener('click', () => ladeUrlaubsantraegeMA(m._id, bereichFarbe));
	zeigeMitarbeiterStunden(schichten, mitarbeiter, m._id, postenID);
}

/**
 * Zeigt die Gesamtstunden des Mitarbeiters an
 * @param {array} schichten
 * @param {array} mitarbeiter
 * @param {string} mitarbeiterID
 * @param {string} postenID
 */
function zeigeMitarbeiterStunden(schichten, mitarbeiter, mitarbeiterID, postenID) {
	const mSchichten = filterSchichtenMitarbeiter(schichten, mitarbeiterID, postenID);
	let gesamtZeit = 0;
	const gesamtElem = document.getElementById(`ge:${postenID}:${mitarbeiterID}`);
	mSchichten.forEach((s) => {
		const schichtZeit = s.BezahlteZeitGesamt;
		gesamtZeit += schichtZeit;
	});
	if (!gesamtElem) return;
	// Dienstplaner Ohne Budget darf die AG Kosten nicht sehen
	if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget)) {
		const kosten = gesamtZeit * mitarbeiter.find((m) => m._id === mitarbeiterID).Uebersicht.AGKostenProStunde;
		gesamtElem.innerHTML = `<div class="h">${convertNumberDE(gesamtZeit)} h</div><div class="k">${convertNumberToEuro(kosten)}</div>`;
	} else {
		gesamtElem.innerHTML = `<div class="h">${convertNumberDE(gesamtZeit)} h</div>`;
	}
}

/**
 * Zeigt alle Schichten an, der Default sind alle Schichten,
 * aber man kann auch eine beliebige Anzahl von Schichten auswählen, z.B. für den jeweiligen Posten
 * @param {array<object>} schichten
 * @param {object} posten
 */
function zeigeSchichten(schichten, posten, postenListe) {
	schichten.forEach((schicht) => {
		// ArbeitAmFeiertag entsteht durch Stempeln am Feiertag und wird im Dienstplan nicht angezeigt
		if (schicht.Zeitbloecke?.[0]?.EgfzID === Egfz.ArbeitAmFeiertag) return;
		const htmlID = `${schicht.Wochentag.Zahl}:${posten._id}:${schicht.MitarbeiterID}`;
		// zeige ein kleines Panel für Schichten in anderen Posten/Bereichen an
		if (schicht.PostenID !== posten._id) {
			createSchichtPanel(schicht, htmlID, postenListe);
			return;
		}
		createSchichtElement(schicht, htmlID);
	});
}
/**
 * Zeige die Schicht Hinzufügen Controls, wenn es in dem Feld keine Schicht gibt.
 * - wir blenden es aus mit style: none, falls es eine schicht gibt.
 */
function zeigeSchichtAddenControls() {
	const gridItems = document.getElementsByClassName('daycell');
	Array.from(gridItems).forEach((tagDiv) => {
		if (tagDiv.id.split(':')[2] !== '-1' && !['ma', 'ms', 'ge'].includes(tagDiv.id.split(':')[0])) {
			// Der Urlaub-Badge (aus addGridRow, basierend auf dem genehmigten Urlaubsantrag) ist überflüssig
			// und wird entfernt, sobald für den Tag bereits eine echte Urlaub-Schicht existiert — die zeigt
			// "Urlaub" (samt Flugzeug-Icon) bereits selbst an, siehe components/shiftCard.js/.egfz-urlaub.
			if (tagDiv.querySelector('.egfz-urlaub')) {
				tagDiv.querySelector('.dbadge.urlaub')?.remove();
			}
			const addButton = schichtAddenTemplate.content.cloneNode(true).children[0];
			tagDiv.appendChild(addButton);
			// Falls der Mitarbeiter an dem Tag nicht arbeitet, verhindern wir die Schicht Hinzufügen Funktion
			// (ausgegraut per CSS: .daycell.ma-inaktiv .span-add)
			if (tagDiv.classList.contains('ma-inaktiv')) {
				addButton.setAttribute('onclick', 'fun.zeigeNachricht(\'Datum liegt außerhalb des Beschäftigungzeitraums!\', 0)');
				return;
			}
			addButton.setAttribute('onclick', `fun.schichtAdden("${tagDiv.id}")`);
			// Bei EGFZ Schichten, Krank oder Urlaub kann der Mitarbeiter keine Weitere Schicht haben
			if (tagDiv.querySelector('.egfz-schicht') || tagDiv.querySelector('.panel-krank') || tagDiv.querySelector('.tag-urlaub')) {
				addButton.style.display = 'none';
			}
		}
	});
}

/**
 * Baut die Tagesnotizen-Zeile (Label + 7 Notiz-Textareas + Wochen-Leerzelle) und befüllt sie mit den
 * gespeicherten Notizen der aktuellen Woche. `idPrefix` sorgt für eindeutige Zellen-IDs pro Grid
 * (Wochenplan `notiz:`, Mitarbeiteransicht `manotiz:`, siehe views/mitarbeiteransichtView.js) — beide
 * Ansichten zeigen dieselben Notizdaten, aber in eigenen DOM-Elementen (getElementById erlaubt keine
 * doppelten IDs). `tb.debounceUpdateTagesnotiz` liest den Wert direkt aus dem Element (nicht per ID),
 * funktioniert also unverändert für beide Zeilen.
 * @param {HTMLElement} gridEl Ziel-Grid-Container
 * @param {string} idPrefix ID-Präfix für die Notiz-Zellen (Default `notiz:`)
 */
async function erstelleTagesnotizenZeile(gridEl, idPrefix = 'notiz:') {
	const notizLbl = document.createElement('div');
	notizLbl.className = 'notizcell lbl';
	notizLbl.innerText = 'Tagesnotizen';
	notizLbl.style.gridColumn = '1 / 3'; // über die ersten beiden Spalten spannen
	gridEl.appendChild(notizLbl);
	for (let i = 1; i <= 7; i += 1) {
		const zelle = document.createElement('div');
		zelle.className = 'notizcell';
		zelle.id = `${idPrefix}${i}`;
		zelle.innerHTML = '<textarea class="tages-notiz" oninput="tb.debounceUpdateTagesnotiz(this)" placeholder="Tagesnotiz..."></textarea>';
		gridEl.appendChild(zelle);
	}
	gridEl.appendChild(Object.assign(document.createElement('div'), { className: 'notizcell num', innerText: 'Woche' }));
	const dpNotizen = await stammdatenService.getTagesnotizenWoche(datumService.laufendesDatum.startOf('week').format('YYYY-MM-DD'), datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD'), stammdatenService.aktuelleBetriebsstaette);
	dpNotizen.forEach((notiz) => {
		// Sonntag ist bei uns der 7. Tag.
		const tagIndex = dayjs(notiz.Datum).tz().day() === 0 ? 7 : dayjs(notiz.Datum).tz().day();
		const notizfeld = document.getElementById(`${idPrefix}${tagIndex}`).querySelector('textarea');
		notizfeld.value = notiz.Notiz;
	});
}

/**
 * Bestückt die Kalenderwochen- und Datumszeile mit aktuellen Daten
 */
async function zeigeWochenDaten() {
	// Tagesnotizen: eine Zeile über dem Spaltenkopf (reale, backend-gestützte Funktion ohne
	// Reference-Äquivalent, siehe toolbar.js:updateTagesNotiz). Reine DOM-Reihenfolge bestimmt die
	// Zeile (kein grid-template-areas mehr, siehe wgrid in dienstplan.css) — muss daher vor den
	// Spaltenköpfen stehen, um darüber zu erscheinen.
	await erstelleTagesnotizenZeile(gridContent, 'notiz:');

	// Spaltenköpfe (Mitarbeiter | Status | 7×Tag | Woche) — direkt darunter.
	const lblKopf = document.createElement('div');
	lblKopf.className = 'colhead lbl';
	lblKopf.innerText = 'Personal';
	gridContent.appendChild(lblKopf);
	gridContent.appendChild(erstelleStatusKopf());

	const heute = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).startOf('day');
	datumService.holeWochenDaten().forEach((tag, i) => {
		const tagNr = i === 6 ? 7 : i + 1; // Montag=1 .. Sonntag=7, wie im Rest des Grids (aria-level/ids)
		const istWochenende = i >= 5;
		const istHeute = tag.isSame(heute, 'day');
		const kopf = document.createElement('div');
		kopf.className = `colhead${istWochenende ? ' we' : ''}${istHeute ? ' today' : ''}`;
		kopf.id = `date:${tagNr}`;
		kopf.innerHTML = `${tag.format('dd')}<small>${tag.format('DD.MM.')}</small>`;
		// Platzhalter fürs Wetter-Icon; wird asynchron (nicht blockierend) befüllt, siehe unten.
		const wetterBadge = document.createElement('span');
		wetterBadge.className = 'wx';
		wetterBadge.setAttribute('data-wetter-tag', tag.format('YYYY-MM-DD'));
		kopf.appendChild(wetterBadge);
		gridContent.appendChild(kopf);
	});
	const wocheKopf = document.createElement('div');
	wocheKopf.className = 'colhead num';
	wocheKopf.innerText =  window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ? 'Stunden\nKosten' : 'Stunden';
	gridContent.appendChild(wocheKopf);

	// Absichtlich nicht awaited: Wetterdaten sind rein dekorativ und dürfen den Dienstplan-Aufbau
	// nie verzögern oder blockieren (auch nicht bei einem langsamen/fehlerhaften API-Aufruf).
	fuelleWetterBadges();
}

/**
 * Hält die Schichtvorlagen (Toolbar-Select + Sidebar-Liste) passend zum Bereich-Filter — aufgerufen nach
 * jedem An-/Abwählen eines Bereichs im Filter-Panel. #bereich-select bestimmt, welcher Bereich die Vorlagen
 * liefert:
 * - angehakter Bereich → die Vorlagen wechseln auf ihn,
 * - der gerade gewählte Vorlagen-Bereich wird abgewählt → Rückfall auf den zuletzt angehakten der noch
 *   gewählten Bereiche; ist keiner mehr gewählt, bleibt es beim bisherigen.
 * @param {string} bereichID an- oder abgewählter Bereich
 * @param {boolean} angehakt
 * @param {array<string>} auswahl danach gewählte BereichIDs, zuletzt angehakter zuletzt
 */
async function passeVorlagenBereichAn(bereichID, angehakt, auswahl) {
	const bereichSelect = document.getElementById('bereich-select');
	if (!bereichSelect) return;
	let zielID = null;
	if (angehakt) {
		zielID = bereichID;
	} else if (bereichSelect.value === bereichID && auswahl.length > 0) {
		zielID = auswahl[auswahl.length - 1];
	}
	if (!zielID || bereichSelect.value === zielID) return;
	if (![...bereichSelect.options].some((option) => option.value === zielID)) return;
	bereichSelect.value = zielID;
	await erstelleToolbarVorlagenSelect();
}

/**
 * Schreibt KW + Datumsbereich der laufenden Woche in die Wochennavigation (#kal-woche). Wird zu Beginn
 * jedes Renderns der Wochen-Ansichten (Wochenplan und Mitarbeiteransicht) aufgerufen — unabhängig davon,
 * ob es Posten/Daten gibt, damit die Anzeige nach jedem Wochen- oder Ansichtswechsel stimmt.
 */
function aktualisiereKwAnzeige() {
	const inputWeek = document.getElementById('kal-woche');
	if (!inputWeek) return;
	inputWeek.innerHTML = `<i class="bi bi-calendar3-range"></i><div><b>KW ${datumService.kalenderWoche}</b><small>${datumService.laufendesDatum.format('DD.MM.')} – ${datumService.laufendesDatum.endOf('week').format('DD.MM.YYYY')}</small></div>`;
}

/**
 * Erstellt ein HTML Select Element zur Qualifikationsauswahl
 * @param {array} qualisMA
 * @param {string} QualifikationID beim Editieren, die bereits eingetragene Qualifikation
 * @returns HTML Select Element
 */
 async function erstelleQualifikationSelect(qualifikationen, qualisMA, QualifikationID = undefined) {
	const select = document.createElement('select');
	select.id = 'input-qualifikation';
	select.className = 'inp';
	// forEach loop does not work correctly with async/await here
	qualisMA.forEach((q) => {
		if (!q.Verwenden) return;
		const newOption = document.createElement('option');
		newOption.setAttribute('value', q.QualifikationID);
		newOption.innerText = findeQualifikation(qualifikationen, q.QualifikationID).BezeichnungNeutral;
		select.appendChild(newOption);
	});
	if (QualifikationID) select.value = QualifikationID;
	return select;
}

/**
 * Erstellt ein HTML Select Element zur Einsatzortauswahl. Anders als bei Posten wird der Einsatzort
 * nicht durch den Grid-Kontext vorgegeben (keine eigene Spalte im Dienstplan) — die Auswahl bleibt
 * immer editierbar, beschränkt sich aber auf die dem/der Mitarbeitenden zugeordneten Einsatzorte
 * (analog zu erstelleQualifikationSelect), plus eine leere "Kein Einsatzort"-Option, da die Zuordnung
 * optional ist.
 * @param {array<object>} alleEinsatzorte Einsatzorte der Betriebsstätte, für das Label-Lookup
 * @param {array<object>} einsatzorteMA die dem/der Mitarbeitenden zugeordneten Einsatzorte ({EinsatzortID})
 * @param {string} EinsatzortID beim Editieren, der bereits eingetragene Einsatzort
 * @returns HTML Select Element
 */
async function erstelleEinsatzortSelect(alleEinsatzorte, einsatzorteMA, EinsatzortID = undefined) {
	const select = document.createElement('select');
	select.id = 'input-einsatzort-select';
	select.className = 'inp';
	const leereOption = document.createElement('option');
	leereOption.setAttribute('value', '');
	leereOption.innerText = 'Kein Einsatzort';
	select.appendChild(leereOption);
	einsatzorteMA.forEach((e) => {
		const einsatzort = findeEinsatzort(alleEinsatzorte, e.EinsatzortID);
		if (!einsatzort._id) return;
		const newOption = document.createElement('option');
		newOption.setAttribute('value', einsatzort._id);
		newOption.innerText = einsatzort.Bezeichnung;
		select.appendChild(newOption);
	});
	if (EinsatzortID) select.value = EinsatzortID;
	return select;
}

/**
 * Erstellt ein HTML Select Element des aktuellen Postens
 * @param {array<object>} postenListe
 * @param {string} postenID die ID des aktuellen Postens — falls leer, wird ein freies Select mit allen
 *   Postens erzeugt (siehe Mitarbeiteransicht, in der eine Zelle keinem festen Posten zugeordnet ist).
 * @param {string} bevorzugtePostenID nur im freien Select relevant: welche Option vorausgewählt werden
 *   soll (z.B. der erste zugeordnete Posten der Person), die Auswahl bleibt trotzdem frei änderbar.
 * @returns HTML Select Element
 */
async function erstellePostenSelect(postenListe, postenID, bevorzugtePostenID = undefined) {
	const select = document.createElement('select');
	select.id = 'input-posten-select';
	select.className = 'inp';
	// Entweder zeigen wir nur den aktuellen Posten an oder ein Select mit allen.
	if (!postenID) {
		postenListe.forEach((b) => {
			const newOption = document.createElement('option');
			newOption.setAttribute('value', b._id);
			newOption.innerText = b.Posten;
			select.appendChild(newOption);
		});
		if (bevorzugtePostenID) select.value = bevorzugtePostenID;
	} else {
		const posten = findePosten(postenListe, postenID);
		select.setAttribute('disabled', '');
		const option = document.createElement('option');
		option.value = posten._id;
		option.innerText = posten.Posten;
		select.appendChild(option);
	}
	return select;
}


/**
 * Zeigt die neue Schicht im Dienstplan an (und ersetzt ggf. die alte Schicht).
 * @param {object} schichtObjekt
 * @param {string} gridId
 */
async function zeigeNeueSchicht(schichtObjekt, gridId) {
	const oldElement = document.querySelector(`[aria-label="${schichtObjekt._id}"]`);
	// Falls es ein altes Element mit der gleichen ID gibt, dann müssen wir dieses aus der Oberfläche entfernen...
	if (oldElement !== null) {
		oldElement.remove();
	}
	// ArbeitAmFeiertag entsteht durch Stempeln am Feiertag und wird im Dienstplan nicht angezeigt
	if (schichtObjekt.Zeitbloecke?.[0]?.EgfzID === Egfz.ArbeitAmFeiertag) return;
	createSchichtElement(schichtObjekt, gridId);
	await updateSummenZeilen(schichtObjekt);
	// Schicht gehört zu einem Bedarf → Bedarfszeile neu aufbauen (Besetzung kann sich geändert haben).
	if (schichtObjekt.BedarfID) aktualisiereBedarfZeilen();
	// schicht panels anzeigen in anderen Posten desselben Bereichs (nicht mehr aus #bereich-select
	// abgeleitet, da seit dem Filter-Panel mehrere Bereiche gleichzeitig sichtbar sein können).
	const postenListe = await stammdatenService.getPosten();
	const postenInBereich = postenListe.filter((p) => _.isEqual(p.BereichID, schichtObjekt.BereichID));
	postenInBereich.forEach((posten) => {
		if (!_.isEqual(posten._id, schichtObjekt.PostenID)) {
			const panelGridID = `${gridId.split(':')[0]}:${posten._id}:${gridId.split(':')[2]}`;
			createSchichtPanel(schichtObjekt, panelGridID, postenInBereich);
		}
	});
}

/**
 * Setzt eine Änderung aus dem Bedarf-Dialog gezielt im Raster um, statt die ganze Ansicht neu zu laden:
 * zugeordnete/entfernte/umgesetzte Schichten werden wie bei normalen Schichtänderungen eingesetzt bzw.
 * entfernt (inkl. Summen und Bedarfszeilen). Voller Neuaufbau nur, wenn es nicht anders geht: die Person hat
 * in dem Posten noch keine Zeile, ein Bedarf hat zugeordnete Schichten mitgeändert, oder die Änderung ist
 * unbekannt (z.B. aus dem Event-Editor).
 * @param {object|undefined} aenderung siehe dialogs/bedarfZuordnung.js:nachAktion
 * @param {object} optionen
 * @param {function} optionen.gridIdFuer (schicht) => ID der Tageszelle, in die die Schicht gehört
 * @param {function} optionen.neuLaden voller Neuaufbau der Ansicht
 */
async function wendeBedarfAenderungAn(aenderung, { gridIdFuer, neuLaden }) {
	if (!aenderung) {
		await neuLaden();
		return;
	}
	if (aenderung.art === 'bedarf') {
		if (aenderung.schichtenGeaendert) {
			await neuLaden();
		} else {
			await aktualisiereBedarfZeilen();
		}
		return;
	}
	const entfernen = { entfernt: [aenderung.schicht], umgesetzt: [aenderung.quelle] }[aenderung.art] ?? [];
	const einsetzen = { zugeordnet: [aenderung.schicht], umgesetzt: [aenderung.ziel] }[aenderung.art] ?? [];
	// Ohne Zielzelle (Person hat in diesem Posten keine Zeile) lässt sich die Karte nicht einsetzen.
	if (einsetzen.some((s) => !s || !document.getElementById(gridIdFuer(s)))) {
		await neuLaden();
		return;
	}
	for (const schicht of entfernen.filter(Boolean)) {
		await entferneSchichtElement(schicht, gridIdFuer(schicht));
	}
	for (const schicht of einsetzen) {
		await zeigeNeueSchicht(schicht, gridIdFuer(schicht));
	}
}

/**
 * Entferne ein schicht Element aus dem Grid und stellt, falls leer, das SchichtAdden Element wieder her.
 * @param {object} schichtObjekt
 * @param {string} gridId
 */
async function entferneSchichtElement(schichtObjekt, gridId) {
	const gridElement = document.getElementById(gridId);
	// gridElement kann fehlen wenn der Posten zu einem deaktivierten Bereich gehört
	if (gridElement) {
		gridElement.querySelector(`[aria-label="${schichtObjekt._id}"]`)?.remove();
		gridElement.classList.remove('wunschzeit-hide');
		if (gridElement.querySelector('.span-add')) {
			gridElement.querySelector('.span-add').style.display = '';
		}
	}
	await updateSummenZeilen(schichtObjekt);
	document.querySelectorAll(`.schicht-panel[aria-label="${schichtObjekt._id}"]`).forEach((elem) => elem.remove());
	// Gelöschte Bedarf-Schicht → der Bedarf ist wieder (teilweise) offen.
	if (schichtObjekt.BedarfID) aktualisiereBedarfZeilen();
}

/**
 * Aktualisiert die jeweiligen Summen Zeilen nach Änderung eines Schicht Objekts.
 * @param {object} schichtObjekt
 */
async function updateSummenZeilen(schichtObjekt) {
	// Berechne Wochensummen und Tagessummen neu. Seit dem Filter-Panel (mehrere Bereiche können
	// gleichzeitig sichtbar sein) laden wir alle Schichten der Woche und filtern clientseitig
	// genauso wie beim vollständigen Render in zeigeDienstplan().
	// Monatsstunden parallel neu laden: Plan (und ggf. Plan bis heute) der Person in der Statuszelle ändern sich mit.
	const [schichten] = await Promise.all([schichtenService.getSchichten(datumService.laufendesDatum), ladeStundenMonat()]);
	const mitarbeiter = await stammdatenService.getMitarbeiter();
	zeigeMitarbeiterStunden(schichten, mitarbeiter, schichtObjekt.MitarbeiterID, schichtObjekt.PostenID);
	await aktualisiereStatusZellen(schichtObjekt.MitarbeiterID);
	if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget)) {
		const postenListe = await stammdatenService.getPosten();
		const postenSchichten = schichten.filter((s) => s.PostenID === schichtObjekt.PostenID);
		zeigePostenSummen(schichtObjekt.PostenID, postenSchichten, mitarbeiter, schichtObjekt.BereichID);
		// Bereichs-Zwischensumme des Bereichs dieser Schicht neu berechnen (eigene Zeile, siehe zeigeDienstplan)
		if (schichtObjekt.BereichID) {
			const postenInBereich = postenListe.filter((po) => po.BereichID === schichtObjekt.BereichID && istPostenSichtbar(po._id));
			const bereichSchichten = schichten.filter((s) => _.pluck(postenInBereich, '_id').includes(s.PostenID));
			zeigePostenSummen(schichtObjekt.BereichID, bereichSchichten, mitarbeiter, schichtObjekt.BereichID);
		}
		// Gesamtsumme über alle sichtbaren Bereiche/Posten neu berechnen
		const sichtbarePostenIDs = _.pluck(postenListe.filter((po) => istBereichSichtbar(po.BereichID) && istPostenSichtbar(po._id)), '_id');
		const sichtbareSchichten = schichten.filter((s) => sichtbarePostenIDs.includes(s.PostenID));
		zeigePostenSummen(-1, sichtbareSchichten, mitarbeiter);
		// Gesamtsumme der Mitarbeiteransicht (falls gerendert) über die dort sichtbaren Mitarbeiterzeilen `ma::<MitarbeiterID>`
		if (document.getElementById(`ma:${MA_GESAMT_ID}:-1`)) {
			const magridContent = document.getElementById('magrid-content');
			const sichtbareMaIDs = new Set([...magridContent.querySelectorAll('[id^="ma::"]')].map((el) => el.id.slice('ma::'.length)));
			zeigePostenSummen(MA_GESAMT_ID, schichten.filter((s) => sichtbareMaIDs.has(s.MitarbeiterID)), mitarbeiter, undefined, 'Summe', magridContent);
		}
	}
}


/**
 * Öffnet den Mitarbeiter-Status-Dialog (Stunden des Abrechnungsmonats, Konten, aktuelle Urlaubsanträge), siehe
 * dialogs/mitarbeiterStatus.js. Die Person wird frisch geladen, damit die Urlaubsanträge aktuell sind.
 * @param {string} maAuswahl MitarbeiterID
 * @param {string} [bereichFarbe] Farbe des Avatars wie in der Mitarbeiterzelle
 */
async function ladeUrlaubsantraegeMA(maAuswahl, bereichFarbe) {
	const mitarbeiterliste = await stammdatenService.getMitarbeiter(true);
	const aktuellerMA = mitarbeiterliste.find((ma) => ma._id === maAuswahl);
	if (!aktuellerMA) return;
	oeffneMitarbeiterStatus({
		mitarbeiter: aktuellerMA,
		stunden: stundenMonat.Mitarbeiter[aktuellerMA._id],
		zeitraum: stundenMonat.Zeitraum,
		zeigeAgKosten: window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget),
		bereichFarbe,
		zeigeUrlaubsantraege: darfUrlaubsantraege(),
		onUrlaubAktion: (antrag, statusUpdate) => updateUrlaubsantragMA(antrag, statusUpdate, aktuellerMA),
	});
}

/** Schichten einer Person in der angezeigten Woche (für den Vorher/Nachher-Vergleich bei Urlaubsaktionen). */
async function ladeWochenschichtenMA(mitarbeiterID) {
	const alle = await schichtenService.getSchichten(datumService.laufendesDatum);
	return alle.filter((s) => s.MitarbeiterID === mitarbeiterID);
}

/**
 * Setzt nach Genehmigen/Ablehnen eines Urlaubsantrags nur die Änderungen dieser Person ins Raster, statt den
 * Dienstplan neu aufzubauen: Schichten der Woche vorher/nachher vergleichen, neue (Urlaubs-)Schichten einsetzen und
 * entfernte austragen — inkl. Summen, Panels und "+"-Button wie bei normalen Schichtänderungen. Danach Monatsstunden
 * und die Statuszellen der Person neu (Resturlaub, Plan-Stunden, offener-Antrag-Punkt).
 * @param {string} mitarbeiterID
 * @param {array<object>} schichtenVorher Wochenschichten der Person vor der Aktion
 */
async function aktualisiereNachUrlaubsaktion(mitarbeiterID, schichtenVorher) {
	const schichtenNachher = await ladeWochenschichtenMA(mitarbeiterID);
	const idsVorher = new Set(schichtenVorher.map((s) => s._id));
	const idsNachher = new Set(schichtenNachher.map((s) => s._id));
	// Zellen-IDs je Ansicht: Mitarbeiteransicht eine Zeile je Person, Wochenplan eine je Posten
	const maAnsicht = !document.getElementById('magrid')?.classList.contains('view-hidden');
	const gridIdFuer = (s) => (maAnsicht ? `${s.Wochentag.Zahl}::${s.MitarbeiterID}` : `${s.Wochentag.Zahl}:${s.PostenID}:${s.MitarbeiterID}`);
	for (const schicht of schichtenVorher.filter((s) => !idsNachher.has(s._id))) {
		await entferneSchichtElement(schicht, gridIdFuer(schicht));
	}
	for (const schicht of schichtenNachher.filter((s) => !idsVorher.has(s._id))) {
		// Ohne Zielzelle (z.B. Posten per Filter ausgeblendet) gibt es nichts einzusetzen.
		if (document.getElementById(gridIdFuer(schicht))) await zeigeNeueSchicht(schicht, gridIdFuer(schicht));
	}
	await stammdatenService.getMitarbeiter(true);
	await ladeStundenMonat();
	await aktualisiereStatusZellen(mitarbeiterID);
}

/**
 * Setzt den Status eines Urlaubsantrags (genehmigen trägt die Urlaubstage als Schichten ein, ablehnen trägt sie
 * aus) und aktualisiert danach nur die betroffene Person im Raster (aktualisiereNachUrlaubsaktion).
 * @param {object} urlaubsantrag
 * @param {string} statusUpdate 'genehmigt' | 'abgelehnt'
 * @param {object} aktuellerMA
 * @returns {Promise<boolean>} true, wenn sich etwas geändert hat (der Dialog schließt sich dann)
 */
async function updateUrlaubsantragMA(urlaubsantrag, statusUpdate, aktuellerMA) {
	if (urlaubsantrag.UrlaubStatus === statusUpdate) {
		zeigeKleineNachricht(`Der Status des Urlaubantrags ist bereits ${statusUpdate}!`);
		return false;
	}
	const genehmigen = statusUpdate === 'genehmigt';
	// Ablehnen nur bei offenen/genehmigten Anträgen (dann müssen die Urlaubstage ausgetragen werden).
	const ablehnen = statusUpdate === 'abgelehnt' && (urlaubsantrag.UrlaubStatus === 'offen' || urlaubsantrag.UrlaubStatus === 'genehmigt');
	if (!genehmigen && !ablehnen) return false;
	const schichtenVorher = await ladeWochenschichtenMA(aktuellerMA._id);
	const erfolg = genehmigen
		? await schichtenService.erstelleUrlaubAusAntrag(aktuellerMA._id, urlaubsantrag._id, statusUpdate)
		: await schichtenService.entferneUrlaub(aktuellerMA._id, urlaubsantrag._id, statusUpdate);
	if (!erfolg) return false;
	await aktualisiereNachUrlaubsaktion(aktuellerMA._id, schichtenVorher);
	return true;
}

export {
	zeigeDienstplan,
	erstellePostenSelect,
	erstelleEinsatzortSelect,
	erstelleQualifikationSelect,
	erstelleSchichtVorlageSelect,
	zeigeNeueSchicht,
	entferneSchichtElement,
	erstelleToolbarVorlagenSelect,
	ladeUrlaubsantraegeMA,
	filterZuruecksetzen,
	addGridRow,
	zeigeMitarbeiterZelle,
	zeigeMitarbeiterStunden,
	ladeStundenMonat,
	erstelleTagesnotizenZeile,
	zeigeSchichtAddenControls,
	filterMitarbeiterAktiv,
	showGridLoader,
	hideGridLoader,
	aktualisiereKwAnzeige,
	wendeBedarfAenderungAn,
	passeVorlagenBereichAn,
	erstelleStatusKopf,
	zeigePostenSummen,
	MA_GESAMT_ID,
};
